export const IKRA_LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_talent-ikra/artifacts/fh6dbh4a_Ikra%20logo_internet-01.png";

export const INSTAGRAM_URL = "https://www.instagram.com/ikra_bialystok/";

export const CONTACT = {
  email: "admin@ikra.org.pl",
  phone: "+48 575 151 951",
  phoneHref: "tel:+48575151951",
  address: "ul. Legionowa 28/608, 15-281 Białystok",
};

export const NAV_LINKS = [
  { label: "Home", href: "#top" },
  { label: "Zespół", href: "#zespol" },
  { label: "Ambasador", href: "#ambasador" },
  { label: "Wartości", href: "#wartosci" },
];

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_talent-ikra/artifacts/t75ycsg8_IMG-20260609-WA0039.jpg";

export const CORE_VALUES = [
  {
    title: "Bądź niezawodny",
    text: "Robimy to, co obiecaliśmy. Konsekwentnie, terminowo, bez wymówek. Można na nas polegać każdego dnia.",
  },
  {
    title: "Miej szacunek",
    text: "Do klienta, partnera i zespołu. Słuchamy, komunikujemy otwarcie i budujemy relacje oparte na zaufaniu.",
  },
  {
    title: "Bądź pozytywny",
    text: "Nastawienie robi robotę. Nawet w trudnych momentach skupiamy się na rozwiązaniach i idziemy dalej.",
  },
  {
    title: "Wspieraj innych",
    text: "Mamy wzajemne plecy. Świętujemy razem sukcesy, pomagamy, gdy jest ciężko i tworzymy zespół, w którym każdy czuje się częścią całości.",
  },
  {
    title: "Bierz odpowiedzialność",
    text: "Bierzemy na klatę własne wyniki i decyzje. Uczymy się na błędach i zawsze staramy się być krok dalej niż wczoraj.",
  },
];

